// Providers will be exported here
// export { AuthProvider } from './AuthProvider';
// export { SupabaseProvider } from './SupabaseProvider';
// export { ThemeProvider } from './ThemeProvider';

// Placeholder export to prevent build errors
export const PROVIDERS_VERSION = "0.1.0";

// Provider components
export { AuthProvider, AuthContext } from "./AuthProvider";
export { SessionProvider } from "./SessionProvider";

// Adapters
export { createNextAuthAdapter } from "./adapters/nextauth";
export { createSupabaseAdapter } from "./adapters/supabase";

// Types
export type {
  AuthContextType,
  AuthProviderProps,
  AuthSession,
  SignInOptions,
} from "./AuthProvider";
